module.exports = __webpack_public_path__ + "images/FUSA_icons/019-euro.3375f096cf48450d3fb9601a144a0488.svg";